import parse from 'html-react-parser';
import dynamic from 'next/dynamic';

import { CopyBlockAlignment, CopyBlockProps } from '../../../components/blocks/CopyBlockBlock';
import { trackImpression, trackLinkClick } from '../../../tracking/components/copyBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { ContentstackSection } from '../../../types/Contentstack';
import { Transformer } from '../../../types/Transformer';

export interface ContentstackCopyBlock extends ContentstackSection {
  copy: string;
  alignment: CopyBlockAlignment;
  tracking_title: string;
}

interface CopyBlockSerializedData {
  children: string;
  alignment: CopyBlockAlignment;
  trackingTitle: string;
  position?: number;
}

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<CopyBlockSerializedData, CopyBlockProps> = {
  Component: dynamic<CopyBlockProps>(() =>
    import('../../../components/blocks/CopyBlockBlock').then((mod) => mod.CopyBlockBlock),
  ),
  getProps: ({ children, ...serializedData }) => {
    const { trackingPosition, trackingTitle, ...restOfSerializedData } = serializedData;
    const placementContext = {
      trackingPosition,
      trackingTitle,
    };

    return {
      children: parse(children),
      onLinkClick: (e: React.MouseEvent) => trackLinkClick(e, placementContext),
      onVisible: () => trackImpression(placementContext),
      ...restOfSerializedData,
    };
  },
};

export const transformer: Transformer<
  ContentstackCopyBlock,
  CopyBlockSerializedData,
  CopyBlockProps
> = ({ _metadata, copy, alignment, tracking_title }) => ({
  uid: _metadata.uid,
  renderer,
  serializedData: {
    children: copy,
    alignment,
    trackingTitle: tracking_title,
  },
});
